'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchAgentResponder = fetchAgentResponder;

var _hubspot = require('hubspot.PortalIdParser');

var _hubspot2 = _interopRequireDefault(_hubspot);

var _noAuthApiClient = require('../../http/noAuthApiClient');

var _noAuthApiClient2 = _interopRequireDefault(_noAuthApiClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function fetchAgentResponder(_ref) {
  var senderId = _ref.senderId,
      agentType = _ref.agentType,
      sessionId = _ref.sessionId;

  var portalId = _hubspot2.default.get();

  return _noAuthApiClient2.default.get('livechat/v1/responder/' + senderId, {
    query: { agentType: agentType, portalId: portalId, sessionId: sessionId }
  });
}